// extracted by mini-css-extract-plugin
module.exports = {"itemLink":"index_itemLink_3gJzL","tag_list":"index_tag_list_2_KhZ","tag_group_name":"index_tag_group_name_1qLtQ","error":"index_error_2qKfb"};